import { Search, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Input } from '@/components/ui/input';
import { cn } from '@/lib/utils';

interface SearchFieldProps {
  value: string;
  onChange: (next: string) => void;
  className?: string;
}

export function SearchField({ value, onChange, className }: SearchFieldProps) {
  const { t } = useTranslation();
  return (
    <div className={cn('relative w-full sm:w-80', className)}>
      <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
      <Input
        type="search"
        inputMode="numeric"
        autoComplete="off"
        placeholder={t('orders.search.placeholder')}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={cn('h-11 pl-9 text-sm', value ? 'pr-10' : 'pr-3')}
      />
      {value && (
        <button
          type="button"
          onClick={() => onChange('')}
          aria-label={t('orders.search.clear')}
          className="absolute right-2 top-1/2 flex h-7 w-7 -translate-y-1/2 items-center justify-center rounded-full text-muted-foreground hover:bg-muted hover:text-foreground"
        >
          <X className="h-4 w-4" />
        </button>
      )}
    </div>
  );
}
